export { NoPropertiesComponent } from './no-properties.component'
export { noPropertiesRoute } from "./constants";